// extracted by mini-css-extract-plugin
module.exports = {"bannerTitle":"index-bannerTitle_2rhg8"};